export const getTitle = (detail) => {
  if (detail) {
    return "Solicitud procesada";
  }
  return "Solicitud de pago";
};

export const DESCRIPTION =
  "En la siguiente vista podrá observar un resumen de los ítems seleccionados para el pago. Para poder realizarlo será redirigido a la plataforma de Helipagos.";
